import { render, staticRenderFns } from "./SVGPallet.vue?vue&type=template&id=06a02997&scoped=true&"
import script from "./SVGPallet.vue?vue&type=script&lang=js&"
export * from "./SVGPallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a02997",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06a02997')) {
      api.createRecord('06a02997', component.options)
    } else {
      api.reload('06a02997', component.options)
    }
    module.hot.accept("./SVGPallet.vue?vue&type=template&id=06a02997&scoped=true&", function () {
      api.rerender('06a02997', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGPallet.vue"
export default component.exports